<template>
  <div>
    <gmap-autocomplete
      :value="newPlace"
      ref="autocomplete"
      type="text"
      :placeholder="$t('Address')"
      class="form-control"
      :select-first-on-enter="true"
      @place_changed="updateAddress"
      @input="newPlace = $event.target.value"
      :disabled="disabled"
    />
  </div>
</template>

<script>
export default {
  name: "google_address_input",
  props: {
    place: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newPlace: this.place,
      lat: null,
      lng: null,
    };
  },
  watch: {
    place: function () {
      this.newPlace = this.place;
    },
    newPlace: function () {
      this.$emit("update", this.newPlace, this.lat, this.lng);
    },
  },
  mounted() {},
  methods: {
    updateAddress(place) {
      if ("formatted_address" in place) {
        this.lat = place.geometry.location.lat();
        this.lng = place.geometry.location.lng();
        this.newPlace = place.formatted_address;
      } else if ("name" in place) {
        this.newPlace = place.name;
      }
    },
  },
};
</script>

<style lang="scss">
.form-control {
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;

  &:disabled {
    background-color: #e9ecef;
    opacity: 1;
    cursor: not-allowed;
  }

  &:focus {
    border-color: #80bdff;
    outline: 0;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  }
}
</style>
